import { styled } from '@/shared/ui';
import { IconButton } from '@/shared/ui/lib/IconButton';

export const StyledIconButton = styled(IconButton)(({ theme }) => ({
  width: '39px',
  height: '39px',
  borderRadius: '50%',
  border: `1px solid ${theme.palette.custom.grey2}`,
  color: theme.palette.common.black,
  '&:hover': {
    backgroundColor: theme.palette.custom.grey3,
    borderColor: theme.palette.custom.grey2,
  },
  '&:active': {
    backgroundColor: theme.palette.custom.grey2,
  },
}));
